import React, { useState, useRef, useEffect } from 'react';
import s from "./ReportButtons.module.css"
import { useUser } from '../../Context/UserContext';
import { showAccessAlert } from "../Utils/Utils";

function ReportButtons({ handleLogsClick, handleExportCSV, handleExportXLSX, handleBalance, handleAutomatization, toggleLogTable }) {
    const arrayButton = ['Выгрузка', 'Автоматизация', 'Лог', 'Шаблон'];
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const { user } = useUser();
    const notAllowedGroups = ['USER_ORG', 'USER', "SETTING_ORG", "ADMIN_VODOKANAL", "ADMIN_ORG"];
    const isNotAllowed = notAllowedGroups.includes(user.role);

    const [hasVS, setHasVS] = useState(false);

    useEffect(() => {
        const fromOrg = user?.organization?.some(org => org.dev_type === "ВС");
        setHasVS(true);
        if (fromOrg) {
            setHasVS(true);
        }
    }, [user]);

    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };

    const handleButtonClick = (buttonText) => {
        if (buttonText === 'Отчёт о потреблении (ЕРИП)') {
            handleExportCSV();
        } else if (buttonText === 'Отчёт за период') {
            handleExportXLSX();
        } else if (buttonText === 'Баланс') {
            handleBalance();
        } else if (buttonText === 'Лог') {
            handleLogsClick();
        } else if (buttonText === 'Автоматизация') {
            if (notAllowedGroups.includes(user.role)) {
                showAccessAlert();
                return;
            }
            handleAutomatization();
        } else if (buttonText === 'Шаблон') {
            if (notAllowedGroups.includes(user.role)) {
                showAccessAlert();
                return;
            }
            setShowDropdown(false); // Close dropdown on button click
        } else {
            setShowDropdown(false);
        }
    };

    return (
        <div className={s.buttonGroup}>
            {arrayButton.map((buttonText, index) => (
                <div key={index}>
                    {buttonText === 'Выгрузка' ? (
                        <div ref={dropdownRef} className={s.frame16} onClick={toggleDropdown}>
                            <div className={s.frame16Text}>
                                {buttonText}
                            </div>
                            {showDropdown && (
                                <div
                                    className="dropdown"
                                    style={{
                                        position: 'absolute',
                                        zIndex: 999,
                                        backgroundColor: '#fff',
                                        border: '1px solid #ccc',
                                        borderRadius: '4px',
                                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                                        padding: '5px',
                                        top: '100%',
                                        width: 'max-content'
                                    }}
                                >
                                    <button
                                        key={0}
                                        type="button"
                                        className="btn btn-outline-dark"
                                        style={{
                                            display: 'block',
                                            width: '100%',
                                            marginBottom: '5px',
                                        }}
                                        onClick={() =>
                                            handleButtonClick('Отчёт о потреблении (ЕРИП)')
                                        }
                                    >
                                        Отчёт о потреблении (ЕРИП)
                                    </button>
                                    <button
                                        key={1}
                                        type="button"
                                        className="btn btn-outline-dark"
                                        style={{
                                            display: 'block',
                                            width: '100%',
                                            marginBottom: '5px',
                                        }}
                                        onClick={() =>
                                            handleButtonClick('Отчёт за период')
                                        }
                                    >
                                        Отчёт за период
                                    </button>
                                    {hasVS && (
                                        <button
                                            key={2}
                                            type="button"
                                            className="btn btn-outline-dark"
                                            style={{
                                                display: 'block',
                                                width: '100%',
                                                marginBottom: '5px',
                                            }}
                                            onClick={() =>
                                                handleButtonClick('Баланс')
                                            }
                                        >
                                            Баланс
                                        </button>
                                    )}
                                </div>
                            )}
                        </div>

                    ) : (
                        <div className={s.frame16} onClick={() => handleButtonClick(buttonText)}>
                            <div className={s.frame16Text} >
                                {buttonText}
                            </div>
                        </div>
                    )}
                </div>
            ))}

        </div>
    );
}

export default ReportButtons;
